<template>
    <div class="position-relative">
        <select
            class="aup-dropdown-select w-100 pl-3 pr-4"
            :class="[
				galleryView ? 'aup-dropdown-select--white' : 'aup-dropdown-select',
				{ 'aup-dropdown-select--disabled': isDisabled || emptyOptions }
			]"
            v-model="local_value"
			:disabled="isDisabled || emptyOptions"
        >
            <option value>error:call:50</option>
            <option v-for="(item, index) in items" :key="`option-${index}`" :value="item.value"></option>
        </select>
        <label class="aup-dropdown-select__label text-uppercase t-micro px-2">error:call:52</label>
    </div>
</template>

<script>
import GalleryVue from '../public-profile/Gallery.vue';
export default {
	name: 'BaseDropdown',
	props: {
		items: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: 'label'
		},
		value: {
			type: String
		},
		placeholder: {
			type: String,
			default: ''
		},
		galleryView: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		emptyOptions() {
			return this.items.length < 1;
		},
        local_value: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
	},
	data() {
		return {
		};
	}
};
</script>


<style lang="scss">
@import '../../assets/scss/all';
.aup-dropdown-select {
	position: relative;
	-webkit-appearance: none;
	box-sizing: border-box;
	border-radius: 0;
	background-color: transparent;
	border-color: $gray-400;
	background-image: url("data:image/svg+xml,%3Csvg width='40' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Ctitle%3Etriangle%3C/title%3E%3Cpath stroke='%236a737b' transform='rotate(-180 20,10)' id='svg_9' d='m2,19l18,-18l18,18l-36,0z' stroke-width='1.5' fill='%236a737b'/%3E%3C/g%3E%3C/svg%3E");
	background-position: calc(100% - 10px), calc(100% - 5px),
		calc(100% - 2.5em) 0.5em;
	background-size: 10px 5px, 5px 5px, 1px 1.5em;
	background-repeat: no-repeat;
	padding-bottom: 8px;
	padding-top: 8px;
	&:hover {
		cursor: pointer;
	}
	&--white {
		color: white;
		border-color: white;
		background-image: linear-gradient(45deg, transparent 50%, #fff 50%),
			linear-gradient(135deg, #fff 50%, transparent 50%);
		option {
			color: black;
		}
	}
	&__label {
		position: absolute;
		background: $sony-white;
		top: 0;
		transform: translateY(-50%);
		left: 7px;
	}

	&--disabled {
		color: $gray-500;
		border-color: $gray-500;
		background-image: linear-gradient(45deg, transparent 50%, $gray-500 50%),
		linear-gradient(135deg, $gray-500 50%, transparent 50%);

		&:hover {
			cursor: default;
		}
	}
}
</style>

